<template>
  <div class="page-wrapper">
    <ChannelSettings @tab="switchTab" v-if="tab_switch == 'channel_settings'"></ChannelSettings>
    <WebsiteSettings @tab="switchTab" v-if="tab_switch == 'app_settings'"></WebsiteSettings>
    <AccountSettings @tab="switchTab" v-if="tab_switch == 'account_settings'"></AccountSettings>
    <UsersSettings @tab="switchTab" v-if="tab_switch == 'users_settings'"></UsersSettings>
  </div>
</template>
<script>
import WebsiteSettings from "./WebsiteSettings.vue";
import ChannelSettings from "./ChannelSettings.vue";
import AccountSettings from "./AccountSettings.vue";
import UsersSettings from "./UsersSettings.vue"
export default {
  components: {
    WebsiteSettings,
    ChannelSettings,
    AccountSettings,
    UsersSettings
  },
  data: () => ({
    tab_switch: "channel_settings",
  }),
  watch: {
    "$route.params.tab"(tab) {
      if (tab) {
        this.tab_switch = tab;
      } else {
        this.tab_switch = "channel_settings";
      }
    },
  },
  mounted() {
    let vm = this;
    if (vm.$route.params.tab) {
      vm.tab_switch = vm.$route.params.tab;
    } else {
      vm.tab_switch = "channel_settings";
    }
  },
  methods: {
    switchTab(tab) {
      let vm = this;
      vm.tab_switch = tab;
      vm.$router.push({ name: "settings_customization", params: { tab: tab } });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
</style>

